import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClaimsUploadComponent } from '@module-claims/pages/claims-upload/claims-upload.component';
import { UploadLogComponent } from '@module-claims/pages/upload-log/upload-log.component';
import {
  ComboBoxModule,
  DropDownListModule
} from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { ClaimsHttpService } from '@module-claims/services/claims-http.service';
import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
import { ClaimsService } from '@module-claims/services/claims.service';
import { NgxsModule } from '@ngxs/store';
import { ClaimsState } from '@module-claims/store/claims.state';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconModule } from '@progress/kendo-angular-icons';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { PanelBarModule, TabStripModule } from '@progress/kendo-angular-layout';
import { ModuleShared } from '@module-shared/module-shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerSelectionComponent } from '@module-claims/pages/customer-selection/customer-selection.component';
import { ClaimDetailsPageComponent } from '@module-claims/pages/claim-details-page/claim-details-page.component';
import { ClaimsReviewTabgroupComponent } from './components/claims-review-tabgroup/claims-review-tabgroup.component';
import { ClaimReportModalComponent } from './components/claim-report-modal/claim-report-modal.component';
import { ClaimsModalState } from './store/claims-modal.state';
import { ClaimsModalService } from './services/claims-modal.service';
import { ClaimDetailComponent } from './components/claim-detail/claim-detail.component';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ClaimsGroupInvoiceFormComponent } from './components/claims-group-invoice-form/claims-group-invoice-form.component';
import { ClaimsSummaryComponent } from './components/claims-summary/claims-summary.component';
import { MenuModule } from '@progress/kendo-angular-menu';
import { FileNamePipe } from '@module-shared/pipes/file-name/file-name.pipe';
import { ReportState } from '@module-report/store/report.state';
import { ReportHttpService } from '@module-report/services/report-http.service';
import { BatchStatisticsGridComponent } from './components/claims-summary/batch-statistics-grid/batch-statistics-grid.component';
import { BatchStatisticsInsightsComponent } from './components/claims-summary/batch-statistics-insights/batch-statistics-insights.component';
import { ClaimsGroupCategoryPipe } from './pipes/claims-group-category/claims-group-category.pipe';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { Claim340bStatusYesNoPipe } from './pipes/claim-340b-status-yes-no/claim-340b-status-yes-no.pipe';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { AuditReportingComponent } from './components/audit-reporting/audit-reporting.component';
import { AuditDisputeStatusPipe } from './pipes/audit-dispute-status/audit-dispute-status.pipe';
import { AuditResolutionStatusPipe } from './pipes/audit-resolution-status/audit-resolution-status.pipe';
import { AuditDonutChartComponent } from './components/audit-reporting/audit-donut-chart/audit-donut-chart.component';
import { AuditLineChartComponent } from './components/audit-reporting/audit-line-chart/audit-line-chart.component';
import { AuditBarChartComponent } from './components/audit-reporting/audit-bar-chart/audit-bar-chart.component';
import { AuditReportingPanelComponent } from './components/audit-reporting/audit-reporting-panel/audit-reporting-panel.component';
import { AuditPercentStackedBarChartComponent } from './components/audit-reporting/audit-percent-stacked-bar-chart/audit-percent-stacked-bar-chart.component';
import { PharmacyDetailsModalComponent } from './components/pharmacy-details-modal/pharmacy-details-modal.component';
import {
  ContractPharmacyModalService,
  InhousePharmacyModalService,
  PharmacyModalService
} from './services/pharmacy-modal.service';
import { ContractPharmacyModalComponent } from './components/contract-pharmacy-modal/contract-pharmacy-modal.component';
import { InhousePharmacyModalComponent } from './components/inhouse-pharmacy-modal/inhouse-pharmacy-modal.component';
import { ContractPharmacyModalState } from './store/contract-pharmacy-modal.state';
import { InhousePharmacyModalState } from './store/inhouse-pharmacy-modal.state';
import { PrescriberDetailsModalComponent } from './components/prescriber-details-modal/prescriber-details-modal.component';
import {
  CEAssociationModalService,
  CEAssociationRemovalModalService,
  PrescriberModalService
} from './services/prescriber-modal.service';
import { CeAssociationModalComponent } from './components/ce-association-modal/ce-association-modal.component';
import { CEAssociationModalState } from './store/ce-association-modal.state';
import { Confidence340bPipe } from './pipes/confidence-340b/confidence-340b.pipe';
import { CeAssociationRemovalModalComponent } from './components/ce-association-removal-modal/ce-association-removal-modal.component';
import { CEAssociationRemovalModalState } from './store/ce-association-removal-modal.state';
import { ClaimsGroupRebateComponent } from './components/claims-group-rebate/claims-group-rebate.component';
import { ClaimsGroupAuditComponent } from './components/claims-group-audit/claims-group-audit.component';
import { Indicator340bPipe } from './pipes/indicator-340b/indicator-340b.pipe';
import { ClaimAuditStatusModalComponent } from './components/claim-audit-status-modal/claim-audit-status-modal.component';
import { ClaimAuditStatusModalState } from './store/claim-audit-status-modal.state';
import { ClaimAuditStatusModalService } from './services/claim-audit-status-modal.service';
import { ContactCeModalComponent } from './components/contact-ce-modal/contact-ce-modal.component';
import { ClaimCEContactModalState } from './store/claim-ce-contact-modal.state';
import { ClaimCEContactModalService } from './services/claim-ce-contact-modal.service';
import { MfpClaimsLandingComponent } from './pages/mfp-claims-landing/mfp-claims-landing.component';
import { AuditClaimSearchModalComponent } from './components/audit-claim-search-modal/audit-claim-search-modal.component';
import { AuditClaimSearchModalService } from './services/audit-claim-search-modal.service';
import { ChartDataValuesPipe } from './pipes/chart-data-values/chart-data-values.pipe';

@NgModule({
  declarations: [
    ClaimsUploadComponent,
    UploadLogComponent,
    CustomerSelectionComponent,
    ClaimDetailsPageComponent,
    ClaimsReviewTabgroupComponent,
    ClaimReportModalComponent,
    ClaimDetailComponent,
    ClaimsGroupInvoiceFormComponent,
    ClaimsSummaryComponent,
    BatchStatisticsGridComponent,
    BatchStatisticsInsightsComponent,
    ClaimsGroupCategoryPipe,
    Claim340bStatusYesNoPipe,
    AuditReportingComponent,
    AuditDisputeStatusPipe,
    AuditResolutionStatusPipe,
    AuditDonutChartComponent,
    AuditLineChartComponent,
    AuditBarChartComponent,
    AuditReportingPanelComponent,
    AuditPercentStackedBarChartComponent,
    PharmacyDetailsModalComponent,
    ContractPharmacyModalComponent,
    InhousePharmacyModalComponent,
    PrescriberDetailsModalComponent,
    CeAssociationModalComponent,
    Confidence340bPipe,
    CeAssociationRemovalModalComponent,
    ClaimsGroupRebateComponent,
    ClaimsGroupAuditComponent,
    Indicator340bPipe,
    ClaimAuditStatusModalComponent,
    ContactCeModalComponent,
    MfpClaimsLandingComponent,
    AuditClaimSearchModalComponent,
    ChartDataValuesPipe
  ],
  imports: [
    CommonModule,
    NgxsModule.forFeature([
      ClaimsState,
      ClaimsModalState,
      ReportState,
      ContractPharmacyModalState,
      InhousePharmacyModalState,
      CEAssociationModalState,
      CEAssociationRemovalModalState,
      ClaimAuditStatusModalState,
      ClaimCEContactModalState
    ]),
    FormsModule,
    ReactiveFormsModule,
    DropDownListModule,
    LabelModule,
    UploadsModule,
    BreadCrumbModule,
    ComboBoxModule,
    GridModule,
    ButtonsModule,
    IconModule,
    DatePickerModule,
    InputsModule,
    ToolBarModule,
    TabStripModule,
    ModuleShared,
    IndicatorsModule,
    DialogModule,
    TooltipModule,
    MenuModule,
    ExcelModule,
    PanelBarModule,
    ProgressBarModule,
    ChartsModule
  ],
  exports: [
    ClaimsUploadComponent,
    UploadLogComponent,
    CustomerSelectionComponent,
    ClaimDetailsPageComponent,
    ClaimsReviewTabgroupComponent,
    ClaimReportModalComponent,
    ClaimDetailComponent,
    ClaimsGroupInvoiceFormComponent,
    ClaimsSummaryComponent,
    BatchStatisticsGridComponent,
    BatchStatisticsInsightsComponent,
    AuditReportingComponent,
    MfpClaimsLandingComponent
  ],
  providers: [
    ClaimsHttpService,
    ClaimsService,
    ClaimsModalService,
    FileNamePipe,
    ReportHttpService,
    PharmacyModalService,
    ContractPharmacyModalService,
    InhousePharmacyModalService,
    PrescriberModalService,
    CEAssociationModalService,
    CEAssociationRemovalModalService,
    ClaimAuditStatusModalService,
    ClaimCEContactModalService,
    AuditClaimSearchModalService
  ]
})
export class ModuleClaims {}
